<div class="hero-banner" #heroBanner data-section-id="about-hero-banner-section" data-section-name="About Hero Banner">

  <div class="hero-banner__content ocultarMobile">

    <img src="https://www.unipay.cl/api/descargaArchivo/banner-queesunipay-desktop.png" alt="Qué es Unipay"
      class="hero-banner__image ocultarMobile" />

  </div>
  <div class="hero-banner__content ocultarDesktop">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner-queesunipay-movil.png"
      alt="Qué es Unipay Movil" class="hero-banner__image" />
  </div>

</div>